import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box } from '@chakra-ui/react';
import { useNodeTemplate } from '../../../hooks';
import { BLACK_HEX, E_FLOW_HEX, WHITE_HEX } from '../../../constants';
import { RFConfigContext } from '../../../contexts';
import { DOT_ENERGY_CONFIG } from './RFDotEnergyNode.config';
/**
 * Component renders "dotEnergy" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFDotEnergyNodeFC = ({ id, selected, data, isConnectable = true }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: DOT_ENERGY_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsx(Box, { "data-templateid": data.templateCode, width: "14px", height: "14px", bg: WHITE_HEX, border: "1px solid", borderRadius: "50%", borderColor: selected ? E_FLOW_HEX : BLACK_HEX, _hover: { borderColor: E_FLOW_HEX } }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFDotEnergyNode = RFDotEnergyNodeFC;
//# sourceMappingURL=RFDotEnergyNode.js.map